module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00286.ff957417.jpg";